import * as THREE from 'three';
import { map } from '../maths';

const AXIAL_TILT = 23.44;
const AXIAL_TILT_RAD = AXIAL_TILT * (Math.PI / 180);

const CYCLE_DAYS_OFFSET = -11.5 // Dec equinox is about 11.5 days before 1st of january

export default {
    addSun() {
        // Coordinates
        this.sunSpherical = new THREE.Spherical(1, Math.PI * 0.42, 0)
        this.sunDirection = new THREE.Vector3()

        // Debug
        this.debugSun = new THREE.Mesh(
            new THREE.IcosahedronGeometry(0.1, 2),
            new THREE.MeshBasicMaterial()
        )
        // this.wrapper.add(this.debugSun)            

        this.computePhi();
        this.computeTheta();
        this.computeDate();
    },

    computeDate() {
        const date = new Date();
        const month = date.getUTCMonth()

        this.dayOfTheYear = month*(365/12)+date.getUTCDate();
        this.secondOfTheDay = date.getUTCHours()*3600+date.getUTCMinutes()*60+date.getUTCSeconds(); 
                
        if(!this.stopAutoDate)
            setTimeout(() => { this.computeDate() }, 1000); 
    },

    // Equinox & Solstices are approximated, leaped years are ignored - https://www.scp.byu.edu/docs/doychart.html 
    computePhi() {
        // 0 is winter solstice (dec), PI/2 is vernal equinox (mar), PI is summer solstice (june), 3*PI/2 is autumnal equinox (sept), PI*2 is winter solstice again
        const earthRadCycle = map(this.dayOfTheYear, 0 + CYCLE_DAYS_OFFSET, 365 + CYCLE_DAYS_OFFSET, 0, Math.PI*2);
        // converts earthRadCycle to a value between -1 and 1 (see cos graph between 0 and 2*PI)
        const tiltFactor = Math.cos(earthRadCycle);
        // map this tiltFactor in radians to update sunSpherical's phi
        const tiltRad = map(tiltFactor, -1, 1, -AXIAL_TILT_RAD, AXIAL_TILT_RAD);
        
        this.sunSpherical.phi = tiltRad + Math.PI/2; // We need to add PI/2 to calibrate properly (otherwise it's 90degrees off)
    },

    // Param must be UTC seconds of day
    computeTheta() {
        this.sunSpherical.theta = map(this.secondOfTheDay, 0, 86400, Math.PI, -Math.PI) + Math.PI/2; // We need to add PI/2 to calibrate properly (otherwise it's 90degrees off)
    },

    updateSun() {
        if(!this.ignoreDate) {
            this.computePhi()
            this.computeTheta();
        }

        this.sunDirection.setFromSpherical(this.sunSpherical)            
        
        if(this.DEBUG) {
            // Debug
            this.debugSun.position
                .copy(this.sunDirection)
                .multiplyScalar(8)
        }
    }
}
